import React, { useState, useEffect } from "react"
import styled from "styled-components"
import breakpoints from "../../../styles/breakpoints"
import colors from "../../../styles/colors"
import fonts from "../../../styles/fonts"
import ProductGallery from "../ProductGallery"
import ProductImageLayout from "./ProductImageLayout"
import { addAction } from "../../../store/actions/cart/index"
import { connect } from "react-redux"
import { isLoading, isAdded } from "../../../store/reducers"
import {
  getGlobalOutOfStock,
  getLocalisedPrice,
  getOptionsData,
  getSelectedVariant,
  getVariantOutOfStock,
  getPreorderStatus,
  getVariantPreorderStatus,
  getProductTags,
  getShippingTime,
  getMadeToOrder,
  getTagExistence,
} from "../../../services/productHelper"
import { capitalizeFirstLetter } from "../../../services/general"
import { replaceMaterialWord } from "../../../services/material"
import { isPackshotImage } from "../../../services/images"
import YellowIcon from "../../../resources/img/ui/swatches/yellow-gold.svg"
import PinkIcon from "../../../resources/img/ui/swatches/rose-gold.svg"
import WhiteIcon from "../../../resources/img/ui/swatches/white-gold.svg"
import RoseWhiteIcon from "../../../resources/img/ui/swatches/rose-gold-white-gold.png"
import RoseYellowIcon from "../../../resources/img/ui/swatches/rose-gold-yellow-gold.png"
import WhiteRoseIcon from "../../../resources/img/ui/swatches/white-gold-rose-gold.png"
import WhiteYellowIcon from "../../../resources/img/ui/swatches/white-gold-yellow-gold.png"
import YellowRoseIcon from "../../../resources/img/ui/swatches/yellow-gold-rose-gold.png"
import YellowWhiteIcon from "../../../resources/img/ui/swatches/yellow-gold-white-gold.png"
import PlatinumIcon from "../../../resources/img/ui/swatches/platinum-engagement.svg"
import { getLocaleOptionValues } from "../../../services/locale"
import { getProductLinkByMaterial } from "../../../services/links"
import { Link } from "gatsby"
import { withTranslation } from "gatsby-plugin-react-i18next"
import ArrowDown from "../../../resources/img/ui/arrows/arrow-down.svg"
import Select from "react-select"
import OnClickButtonGreen from "../../Core/Buttons/OnClickButtonGreen"
import InfoColumns from "./InfoColumns"
import ProductBreadcrumbs from "../ProductBreadcrumbs"
import { getPinterestProductId } from "../../../services/tracking/pinterest"
import storage from "../../../services/localStorage"
import SizeChartPopup from "../SizeChartPopUp"
import RingSizerPopup from "../RingSizerPopup"
import NomaPopup from "../NomaAlphabetPopUp"
import MementoPopup from "../MementoAlphabetPopUp"
import { isBrowser } from "../../../services/browser"
import { useBannerContext } from "../../../context/BannerContext"
import { cvgTrack } from "../../../services/converge"
import ButtonGreen from "../../Core/Buttons/ButtonGreen"
import KlarnaWidget from "../../Core/KlarnaWidget"

import ShippingIcon from "../../../resources/img/pdp/pdp-shipping.svg"
import HeartIcon from "../../../resources/img/pdp/pdp-heart.svg"
import HandsIcon from "../../../resources/img/pdp/pdp-hands.svg"
import DiamondIcon from "../../../resources/img/pdp/pdp-diamond.svg"
import GlobeIcon from "../../../resources/img/pdp/pdp-globeicon.svg"
import BoxIcon from "../../../resources/img/pdp/pdp-boxicon.svg"
import DiscountSticker from "../DiscountSticker"
import AlmaWidget from "../../Core/AlmaWidget"
import { useLocation } from "@reach/router"
import WhatsappImg from "../../../resources/img/whatsapp/whatsapp-green.svg"

import { getIsFrance } from "../../../services/locale"

let activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || "us"

if (activeEnv === "staging" || activeEnv === "development") {
  activeEnv = "us"
}

const isUK = activeEnv === "uk"
const isUS = activeEnv === "us"

const getCurrencySymbol = () => {
  if (isUK) return "£"
  if (isUS) return "$"
  return "€"
}

const BlockContainer = styled.div`
  ${fonts.openSans};
  @media (min-width: ${breakpoints.lg}) {
    padding: 0 42px;
  }
`
const ComingSoonButton = styled.button`
  background-color: grey;
  color: white;
  padding: 16px 40px;
  border: 1px solid grey;
  font-weight: 700;
  font-size: 12px;
  text-transform: uppercase;
  cursor: not-allowed;
  opacity: 0.7;
  pointer-events: none;
  width: 100%;
  border-radius: 0px;
  text-align: center;
  height: 57px;

  @media (min-width: ${breakpoints.lg}) {
    position: relative;
    z-index: 0;
  }
`

// Container of each icon and text
const IconsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
  align-items: center;
  margin-top: 12px;
  width: 100%;
  padding: 0 20px;
  overflow: hidden;

  @media (min-width: ${breakpoints.lg}) {
    margin-top: 20px;
  }
`

// Flexibility for each button's width to adjust based on content
const IconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 0.5px solid ${colors.trueBlack};
  border-radius: 30px;
  padding: 7px 8px;
  max-width: 168px;
  width: auto;
  background-color: ${colors.lightBackground};
  text-align: center;
  height: 31px;
  min-width: 0px;
  gap: 7px;
  flex-shrink: 1;

  img {
    width: 15px;
    height: 15px;
  }
`

// text beside the icon
const IconsText = styled.span`
  font-size: 8px;
  color: ${colors.trueBlack};
  white-space: nowrap;
  text-align: left;

  @media (min-width: ${breakpoints.lg}) {
    font-size: 10px;
  }
`

const Mobile = styled.div`
  @media (min-width: ${breakpoints.lg}) {
    display: none;
  }
`

const Desktop = styled.div`
  display: none;

  @media (min-width: ${breakpoints.lg}) {
    display: block;
  }
`
const Block = styled.div`
  max-width: ${breakpoints.xxl};
  margin: auto;
  @media (min-width: ${breakpoints.lg}) {
    padding-top: 28px;
  }
`

const Grid = styled.div`
  @media (min-width: ${breakpoints.lg}) {
    display: grid;
    grid-template-columns: calc(50% + 30px) 1fr;
    gap: 30px;
  }
  @media (min-width: ${breakpoints.xxl}) {
    grid-template-columns: 734px 1fr;
    gap: 63px;
  }
`

const Details = styled.div`
  padding: 0 20px;
  position: relative;

  @media (min-width: ${breakpoints.md}) {
    padding: 0 32px;
  }
  @media (min-width: ${breakpoints.lg}) {
    padding: 0;
  }
`

const TitleSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
`

const PriceSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: ${(props) => (props.sale ? "flex-end" : "stretch")};
  position: relative;
`

const Line = styled.div`
  position: absolute;
  background: ${colors.mediumDarkGrey};
  height: 1px;
  width: 110%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const Price = styled.div`
  ${fonts.TTNormsPro};
  font-weight: ${(props) => (props.$crossed ? "400" : "400")};
  font-size: ${(props) => (props.$crossed ? "14px" : "16px")};
  line-height: 1;
  position: relative;
  color: ${(props) =>
    props.sale
      ? colors.black
      : props.$crossed
        ? colors.mediumDarkGrey
        : colors.black};
  font-style: ${(props) => (props.$crossed ? "italic" : "none")};
  margin-left: ${(props) => (props.sale ? "8px" : "0")};

  @media (min-width: ${breakpoints.md}) {
    ${fonts.americana};
    font-weight: ${(props) => (props.$crossed ? "400" : "600")};
    line-height: 1;
    font-size: ${(props) => (props.$crossed ? "16px" : "20px")};
    .currency {
      ${fonts.americana};
    }
  }
`

const ProductTitle = styled.h2`
  ${fonts.americana};
  font-size: 16px;
  line-height: 44px;
  padding-right: 10px;
  color: ${colors.trueBlack};

  @media (min-width: ${breakpoints.lg}) {
    font-size: 20px;
    line-height: 44px;
  }
`

const PageTitle = styled.h1`
  ${fonts.openSans};
  font-size: 10px;
  font-weight: 300;
`

const ColorOptions = styled.div`
  margin: 17px 0;
  display: flex;
  align-items: center;

  @media (min-width: ${breakpoints.lg}) {
    margin: 20px 0;
  }
`

const ColorOptionName = styled.div`
  ${fonts.TTNormsPro};
  ${colors.greyBorders};
  font-size: 12px;
  line-height: 1.17;
  // text-transform: uppercase;
  font-weight: 400;
  padding-right: 20px;

  @media (min-width: ${breakpoints.lg}) {
    font-size: 14px;
    line-height: 1;
  }
`

const OptionName = styled.div`
  ${fonts.openSans};
  font-size: 12px;
  line-height: 1.17;
  text-transform: uppercase;
  font-weight: 600;
  padding-right: 20px;
  margin-top: 16px;

  @media (min-width: ${breakpoints.lg}) {
    font-size: 14px;
    line-height: 1;
  }
`

const ColorOptionValues = styled.div`
  display: flex;
  align-items: center;
`

const ColorOptionValueLink = styled(Link)`
  margin-right: 24px;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: ${(props) => (props.selected ? `1px solid ${colors.black}` : "none")};
  border-radius: 50%;

  img {
    width: 17px;
    height: 17px;
  }
`

const CustomSelect = styled(Select)`
  ${fonts.openSans};
  font-weight: 600;
  margin-top: 12px;
  text-transform: ${(props) => !props.studText && "capitalize"};
  display: ${(props) => (props.isRingSize ? "none" : "block")};
  @media (min-width: ${breakpoints.md}) {
    margin: 16px 0;
    display: ${(props) => (props.type || props.isRingSize ? "none" : "block")};
  }
  @media (min-width: ${breakpoints.lg}) {
    display: ${(props) => (props.type || props.isRingSize ? "none" : "block")};
  }
`

const TypeOptions = styled.fieldset`
  display: none;

  @media (min-width: ${breakpoints.md}) {
    display: grid;
    grid-template-columns: ${(props) =>
      props.single ? "1fr" : (props) => `repeat(${props.cols}, 1fr)`};
    gap: 20px;
    margin: 16px 0;
  }
`

const TypeRadio = styled.label`
  background: ${colors.white};
  padding: 20px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid;
    border-color: ${colors.secondaryBeige};
  }

  input:checked ~ .checkmark {
    border-color: ${colors.green};
  }

  input {
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }
`

const EngravingContainer = styled.div`
  width: 100%;
  margin: 16px 0;
  label {
    ${fonts.helveticaNeue};
    font-size: 11px;
    line-height: 11px;
    color: ${colors.black};
    display: block;
    width: 100%;
    text-align: right;
    margin-top: 2px;
  }
`

const OrderNumberFieldContainer = styled.div`
  width: 100%;
  margin: 16px 0 8px 0;
  label {
    ${fonts.helveticaNeue};
    font-size: 11px;
    line-height: 11px;
    color: ${colors.black};
    display: block;
    width: 100%;
    text-align: right;
    margin-top: 2px;
  }
`

const OptionalEngraving = styled.input`
  width: 100%;
  background: ${colors.white};
  border: 1px solid ${colors.secondaryBeige};
  padding: 0px 15px 0px 10px;
  height: 57px;
  ${fonts.openSans};
  letter-spacing: 0.2px;
  color: ${colors.greyBorders};
  font-size: 13px;
  line-height: 18px;
  ::placeholder {
    opacity: 0.7;
    ${fonts.openSans};
    font-size: 13px;
    color: #444444;
    letter-spacing: 0.3px;
    line-height: 18px;
    font-style: italic;
  }
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  &:hover,
  &:active,
  &:focus {
    text-decoration: none;
    outline: none;
    box-shadow: none;
  }
`

const RingSizerBlock = styled.fieldset``

const RingSizerOption = styled.div`
  margin-bottom: 16px;

  &:last-of-type {
    margin-bottom: 0;
  }

  @media (min-width: ${breakpoints.md}) {
    display: ${(props) => (props.grid ? "grid" : "block")};
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    gap: 8px;
  }
`

const RingSizerOptionRadio = styled.label`
  ${fonts.openSans};
  color: ${colors.black};
  display: block;
  font-size: 14px;
  line-height: 1.29;
  font-weight: 700;
  text-transform: uppercase;
  position: relative;
  padding-left: 36px;

  button {
    ${fonts.openSans};
    font-size: 10px;
    font-weight: 400;
    display: block;
    text-transform: none;
    padding: 0;
    background: transparent;
    border: none;
    text-decoration: underline;
    text-underline-offset: 2px;
    margin-top: 4px;
    cursor: pointer;
    text-align: left;
  }

  input {
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 3px;
    left: 0;
    height: 18px;
    width: 18px;
    background-color: ${colors.white};
    cursor: pointer;
    border-radius: 50%;
    border: 1px solid ${colors.green};
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark::after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  input:checked ~ .checkmark::after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .checkmark::after {
    left: 2px;
    top: 2px;
    width: 12px;
    height: 12px;
    background: ${colors.lightGreen};
    border-radius: 50%;
  }
`

const AddToBagContainer = styled.div`
  width: 100%;
  position: fixed;
  bottom: 0;
  z-index: 700;

  div,
  button,
  a {
    width: 100%;
    font-size: 16px;
    padding: 20px;
  }

  @media (min-width: ${breakpoints.lg}) {
    position: relative;
    margin-top: 19px;
    z-index: 0;
  }
`

const BreadcrumbsContainer = styled.div`
  margin-bottom: 18px;
  display: none;

  @media (min-width: ${breakpoints.lg}) {
    display: block;
  }
`

const Message = styled.div`
  margin: 6px auto 0;
  color: ${colors.black};
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  padding: 0 20px;
  text-align: center;

  a {
    color: ${colors.green};
    text-decoration: none;
  }

  &:first-of-type {
    margin-top: 15px;
  }
  &:last-of-type {
    margin-bottom: 15px;
  }

  @media (min-width: ${breakpoints.md}) {
    padding: 0 32px;
    font-size: 13px;
  }
  @media (min-width: ${breakpoints.lg}) {
    text-align: left;
    padding: 0;
  }
`

const WidgetContainer = styled.div`
  /* margin-top: 12px; */
  div {
    text-align: right;
  }
`

const optionIcons = {
  "yellow gold": YellowIcon,
  "rose gold": PinkIcon,
  "white gold": WhiteIcon,
  "yellow gold & white gold": YellowWhiteIcon,
  "white gold & rose gold": WhiteRoseIcon,
  "yellow gold & rose gold": YellowRoseIcon,
  "white gold & yellow gold": WhiteYellowIcon,
  "rose gold & yellow gold": RoseYellowIcon,
  "rose gold & white gold": RoseWhiteIcon,
  platinum: PlatinumIcon,
}

const DetailList = styled.ul`
  margin-top: 18px;
  padding: 0 20px;
  color: ${colors.black};
  display: ${(props) => (props.$hiddenMb ? "none" : "block")};

  li {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 1.5;
    font-weight: 400;

    img {
      padding-right: 18px;
      width: 42px;
    }
  }

  @media (min-width: ${breakpoints.md}) {
    padding: 0 32px;
    margin-top: 26px;
    display: ${(props) => (props.$hiddenDesktop ? "none" : "block")};
    li {
      font-size: 14px;
      margin-bottom: 3px;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
  @media (min-width: ${breakpoints.lg}) {
    padding: 0;
  }
`

export const dropdownStyles = (hideDropdown = false) => {
  return {
    control: (styles) => ({
      ...styles,
      backgroundColor: "white",
      height: "57px",
      width: "100%",
      paddingLeft: "10px",
      border: "1px solid " + colors.secondaryBeige,
      borderRadius: "none",
      color: colors.greyBorders,
      fontSize: "16px",
      cursor: hideDropdown ? "no-drop" : "pointer",
      letterSpacing: 0,
      lineHeight: "20px",
      marginRight: "16px",
      boxShadow: "none",
      textAlign: "center",
      "&:hover": {
        borderColor: colors.secondaryBeige,
      },
    }),
    menu: (styles) => ({
      ...styles,
      fontSize: "13px",
      border: "1px solid " + colors.secondaryBeige,
      borderRadius: "none",
      color: colors.black,
      width: "100%",
      display: hideDropdown ? "none" : "block",
    }),
    option: (styles, { isSelected }) => ({
      ...styles,
      color: colors.black,
      backgroundColor: isSelected ? colors.secondaryBeige : colors.white,
      cursor: "pointer",
      textAlign: "center",
      "&:hover": {
        color: colors.black,
        backgroundColor: isSelected
          ? colors.secondaryBeige
          : "rgba(209,193,182, 0.5)",
      },
      ":active": {
        color: colors.black,
        backgroundColor: "rgba(209,193,182, 0.5)",
      },
    }),
    valueContainer: (styles) => ({ ...styles, padding: 0 }),
    indicatorSeparator: (styles) => ({ ...styles, display: "none" }),
    indicatorsContainer: (styles) => ({
      ...styles,
      background: "url(" + ArrowDown + ") no-repeat",
      backgroundSize: "10px 6px",
      backgroundPosition: "right 10px center",
      width: "20px",
      opacity: hideDropdown ? "0" : "1",
    }),
    dropdownIndicator: (styles) => ({ ...styles, display: "none" }),
    singleValue: (styles) => ({ ...styles, paddingLeft: "0" }),
  }
}

const Sticky = styled.div`
  display: grid;
  @media (min-width: ${breakpoints.lg}) {
    position: sticky;
    top: ${(props) => props.top + 113}px;
    height: max-content;
  }
`
const NomaButton = styled.div`
  ${fonts.openSans};
  font-size: 10px;
  font-weight: 400;
  display: block;
  text-transform: none;
  padding: 0;
  background: transparent;
  border: none;
  margin-top: 6px;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
  text-align: left;
`

const Whatsapp = styled.a`
  /* display: flex; */
  align-items: center;
  border-radius: 69.5px;
  border: 1px solid black;
  border-radius: 0;
  justify-content: center;
  height: 57.46px;
  gap: 6px;
  box-shadow: none;
  color: ${colors.trueBlack};
  text-decoration: none;
  margin-top: 14px;
  border-left: none;
  border-right: none;
  display: none;
  @media (min-width: ${breakpoints.lg}) {
    display: flex;
    border-left: 1px solid black;
    border-right: 1px solid black;
    border-radius: 20px;
    box-shadow: 0px 4px 4px 0px #00000040;
  }

  img {
    padding-top: 19px;
    padding-bottom: 17.46px;
  }

  &:hover {
    background-color: #25d366;

    color: white;
    border-color: white;
    img {
      filter: brightness(3);
    }
  }
`

const LearnMoreLink = styled(Link)`
  color: inherit;
`

const WhatsappText = styled.span`
  ${fonts.ivyStyleLight};
  font-size: 16px;
  line-height: 14px;
  padding: 21.03px 0;
  text-decoration: none;
`
const ProductDetails = ({
  product,
  content,
  title,
  h1,
  material,
  wedding,
  description,
  collections,
  isAdded,
  isLoading,
  addAction,
  prevState,
  t,
  comingSoon,
  letterEdit,
}) => {
  const location = useLocation()
  const path = location.pathname
  const activeEnv =
    process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || "development"

  let colorVariants = product.variants
    .sort((a, b) => (a.position > b.position ? 1 : -1))
    .sort((a, b) => {
      return parseFloat(a.price) - parseFloat(b.price)
    })
    .filter((variant) => {
      if (material) {
        let isColorVariant = false
        const selectedOptions = variant.selectedOptions

        const colourOption = selectedOptions.find(
          (option) =>
            option.name.toLowerCase() === "color" ||
            option.name.toLowerCase() === "colour"
        )

        if (colourOption) {
          isColorVariant = colourOption.value
            .toLowerCase()
            .includes(material.value)
        }

        return isColorVariant ? variant : null
      } else {
        return variant
      }
    })

  const getDefaultVariant = (prevState) => {
    let defaultVariant = null

    if (prevState && prevState.options) {
      defaultVariant = colorVariants.find((variant) => {
        //Looking for different colour variant of same option
        let selectedOptions = variant.selectedOptions.filter(
          (option) => option.name !== "Color"
        )
        let isVariant = false

        for (let i = 0; i < selectedOptions.length; i++) {
          let variantOption = selectedOptions[i]
          let optionName = variantOption.name
          let optionValue = variantOption.value

          if (prevState.options[optionName] !== optionValue) {
            isVariant = false

            break
          }

          isVariant = true
        }

        if (isVariant) {
          return variant
        } else {
          return null
        }
      })
    }

    if (!defaultVariant) {
      defaultVariant = colorVariants.find(
        (variant) => !variant.title.toLowerCase().includes("ring sizer")
      )
    }

    return defaultVariant
  }

  const [selectedVariant, setSelectedVariant] = useState(
    getDefaultVariant(prevState)
  )
  const [options, setOptions] = useState(
    prevState?.options || getOptionsData(selectedVariant, false)
  )
  const [engagementOrderNumber, setEngagementOrderNumber] = useState(
    prevState?.engagementOrderNumber || {}
  )
  const [engravings, setEngravings] = useState(prevState?.engravings || {})
  const [knowsSize, setKnowsSize] = useState(true)
  const [isChartPopupOpen, setIsChartPopupOpen] = useState(false)
  const [isSizerPopupOpen, setIsSizerPopupOpen] = useState(false)
  const [isLetterPopupOpen, setIsLetterPopupOpen] = useState(false)

  // Only used for bracelets
  const [braceletOptions, setBraceletOptions] = useState(
    prevState?.braceletOptions || {}
  )

  //only for cube men bracelet
  const [engravingLimit, setEngravingLimit] = useState(
    prevState?.engravingLimit || 1
  )

  //set variant from colour change
  useEffect(() => {
    if (isBrowser()) {
      const currentUrl = new URL(window.location.href)
      const searchParams = currentUrl.searchParams
      let variantId = searchParams.get("variant")
      let variantFromSearchParam
      let requireRingSizer = false

      if (variantId) {
        variantFromSearchParam = product.variants.find((i) =>
          i.shopifyId.includes(variantId)
        )
      }

      if (variantFromSearchParam) {
        requireRingSizer = variantFromSearchParam.title
          .toLowerCase()
          .includes("ring sizer")
          ? false
          : true
        setSelectedVariant(variantFromSearchParam)
        setOptions(getOptionsData(variantFromSearchParam, false))
        setKnowsSize(requireRingSizer)
      }
    }
  }, [product.variants])

  const changeOption = (optionName, selected) => {
    let newOptions = { ...options }

    if (selected) {
      newOptions[optionName] = selected.value
    }

    const newSelectedVariant = getSelectedVariant(product, newOptions)

    setOptions(newOptions)
    setSelectedVariant(newSelectedVariant)
  }

  const setEngagementRingOrderNumberValue = (e) => {
    setEngagementOrderNumber({
      engagementOrderNumber: {
        key: "Engagement Ring Order Number",
        value: e.target.value,
      },
    })
  }

  const setEngraving = (e, engraving) => {
    const newEngravings = { ...engravings }
    newEngravings[engraving.type] = {
      key: engraving.basketName,
      value: e.target.value,
    }

    setEngravings(newEngravings)
  }

  const setBraceletOption = (e, optionName) => {
    const newOptions = { ...braceletOptions }

    newOptions[optionName] = {
      key: optionName,
      value: e.value,
    }

    setBraceletOptions(newOptions)
  }

  const updateKlaviyo = () => {
    if (typeof window != "undefined") {
      let i = 0

      let checkLearnq = setInterval(function () {
        i++

        if (window._learnq || i > 10) {
          clearInterval(checkLearnq)

          let _learnq = window._learnq || []

          let item = {
            Name: product.title,
            ProductID: product.shopifyId,
            Categories: product.tags,
            ImageURL: product.media[0].image.src,
            URL:
              process.env.WEBSITE_URL_WITH_PREFIX +
              getProductLinkByMaterial(
                content.urlKey,
                material?.value,
                product.createdAt,
                material ? false : true
              ),
            Brand: "Kimaï",
            Price: parseFloat(selectedVariant.price),
          }

          _learnq.push(["track", "Viewed Product", item])
          _learnq.push([
            "trackViewedItem",
            {
              Title: item.Name,
              ItemId: item.ProductID,
              Categories: item.Categories,
              ImageUrl: item.ImageURL,
              Url: item.URL,
              Metadata: {
                Brand: item.Brand,
                Price: item.Price,
              },
            },
          ])

          // Retention tracking
          var vpitem = {
            name: item.Name,
            price: item.Price,
            productID: item.ProductID,
            categories: item.Categories,
            imageURL: item.ImageURL,
            URL: item.URL,
            brand: item.Brand,
          }

          if (window.location.href.includes("vge=true")) {
            console.log("Viewed Product Reclaim", vpitem)
          }

          const geq = window.geq

          // Trigger the event with the product data
          if (typeof geq !== "undefined" && typeof geq.event === "function") {
            //Note: You can change the first argument to anything you need
            geq.event("Viewed Product Reclaim", vpitem)
          }
        }
      }, 100)
    }
  }

  useEffect(() => {
    if (isBrowser()) {
      cvgTrack({
        event: "Viewed Product",
        properties: {
          variant_id: selectedVariant.shopifyId.split("/").pop(),
          product_id: product.shopifyId.split("/").pop(),
          sku: product.handle,
          name: product.title,
          variant_name: selectedVariant.title,
          price: parseFloat(selectedVariant.price),
          currency: product.priceRangeV2.minVariantPrice.currencyCode,
          vendor: "kimai",
        },
      })
    }
  }, [])

  useEffect(() => {
    let pintrk = window.pintrk
    let pinterestProductId = getPinterestProductId(product, selectedVariant)

    if (typeof pintrk === "function") {
      pintrk("track", "pagevisit", {
        line_items: [
          {
            product_id: pinterestProductId,
          },
        ],
      })
    }
    updateKlaviyo()
  }, [])

  let mainImageNumber = null
  let sliderImages = []
  let variantImages = {}
  let currentVariant = selectedVariant
  let colourImageVariant = selectedVariant

  let mainImage

  const isFrance = getIsFrance()

  colorVariants.forEach((variant) => {
    if (!currentVariant) {
      currentVariant = variant
      colourImageVariant = variant
    }

    if (!currentVariant.media) {
      colourImageVariant = variant
    }

    if (colourImageVariant && colourImageVariant.media) {
      let imageId = colourImageVariant.media?.[0]?.id
      if (imageId) {
        variantImages[variant.shopifyId] = imageId
      }
    }
  })

  if (product.media && product.media.length > 0) {
    product.media.forEach((media) => {
      if (!media || !media.image) return

      let mediaId = media.id

      if (!mainImage) {
        if (variantImages[colourImageVariant.shopifyId] === mediaId) {
          mainImage = media.image
        }
      }

      if (!mainImage) {
        if (variantImages[Object.keys(variantImages)[0]] === mediaId) {
          mainImage = media
        }
      }

      if (media.image.gatsbyImageData && !isPackshotImage(media.image.src)) {
        sliderImages.push(media.image)
      }
    })
  }

  const productOptions = product.options
  const productType = product.productType.toLowerCase()
  const isRing = productType === "ring" || productType === "rings" || wedding

  let isSoldIndividually = false
  let colorOptions = []
  let colorOptionName
  const dropdowns = []

  const handleRingSizerOption = (requiresSizer, optionName, values) => {
    let newSizeValue
    if (requiresSizer) {
      setKnowsSize(false)
      newSizeValue = values.find((val) =>
        val.value.toLowerCase().includes("ring sizer")
      )
    } else {
      setKnowsSize(true)
      newSizeValue = values.find(
        (val) =>
          val.value.toLowerCase() !== "decide later" &&
          !val.value.toLowerCase().includes("ring sizer")
      )
    }
    changeOption(optionName, newSizeValue)
  }

  productOptions.forEach((option, index) => {
    let studText = false
    let isColour = false
    let isType = false
    let optionsData = []
    let isSize = false

    let optionName = option.name.toLowerCase()

    if (optionName === "colour" || optionName === "color") {
      isColour = true
      colorOptionName = option.name
    }

    if (optionName.includes("type")) {
      isType = true
    }

    if (optionName === "size") {
      isSize = true
    }

    if (
      optionName === "diamond size" &&
      (productType === "earring" || productType === "earrings")
    ) {
      studText = true
    }

    if (productType === "earrings") {
      isSoldIndividually = true
    }

    option.values.forEach((value) => {
      const lowerCaseValue = value.toLowerCase()

      if (
        lowerCaseValue === "single" ||
        lowerCaseValue === "pair" ||
        lowerCaseValue === "left" ||
        lowerCaseValue === "right"
      ) {
        isType = true
        isSoldIndividually = true
      }

      if (isColour) {
        let iconValue = lowerCaseValue

        colorOptions.push({
          value: value,
          label: getLocaleOptionValues(value),
          icon: optionIcons[iconValue],
        })
      } else {
        if (studText) {
          optionsData.push({
            value: value,
            label: `${getLocaleOptionValues(value)} ${t("pdp.for_each_stud")}`,
          })
        } else {
          const colorVariantOptions = []
          colorVariants.forEach((variant) => {
            const selectedOptions = variant.selectedOptions

            selectedOptions.forEach((selected) => {
              if (selected.name.toLowerCase() === optionName) {
                colorVariantOptions.push(selected.value)
              }
            })
          })

          if (colorVariantOptions.includes(value)) {
            optionsData.push({
              value: value,
              label: getLocaleOptionValues(value),
            })
          }
        }
      }

      if (isType) {
        optionsData.sort((a, b) => (a.value.toLowerCase() === "pair" ? 1 : -1))
      }
    })

    let selectedValue = options[option.name]

    if (isRing && isSize) {
      const selected = optionsData.find((data) => data.label === selectedValue)
      const hasRingsizerOption = optionsData.find((data) =>
        data.value.toLowerCase().includes("ring sizer")
      )

      if (hasRingsizerOption) {
        dropdowns.push(
          <RingSizerBlock key={`${option.name}-${index}`}>
            <RingSizerOption>
              <RingSizerOptionRadio>
                <input
                  onChange={() =>
                    handleRingSizerOption(true, option.name, optionsData)
                  }
                  value={"include_ring_sizer"}
                  id={"include_ring_sizer"}
                  name={"ringSizer"}
                  type="radio"
                  checked={knowsSize === false}
                />
                <span className="checkmark" />
                {t("pdp.ring.order_ring_sizer")}
                <button onClick={() => setIsSizerPopupOpen(true)}>
                  {t("pdp.ring.more_info")}
                </button>
              </RingSizerOptionRadio>
            </RingSizerOption>
            <RingSizerOption grid>
              <RingSizerOptionRadio>
                <input
                  onChange={() =>
                    handleRingSizerOption(false, option.name, optionsData)
                  }
                  value={"exclude_ring_sizer"}
                  id={"exclude_ring_sizer"}
                  name={"ringSizer"}
                  type="radio"
                  checked={knowsSize === true}
                />
                <span className="checkmark" />
                {t("pdp.ring.size_aware")}
                <button
                  onClick={(e) =>
                    setIsChartPopupOpen(true, option.name, e, optionsData)
                  }
                >
                  {t("pdp.ring.size_chart")}
                </button>
              </RingSizerOptionRadio>
              <div>
                <CustomSelect
                  options={optionsData}
                  styles={dropdownStyles(knowsSize === false)}
                  filterOption={(option) =>
                    knowsSize
                      ? !option.value.toLowerCase().includes("ring sizer")
                      : option.value.toLowerCase() === "decide later"
                  }
                  defaultValue={optionsData[0]}
                  value={selected}
                  isSearchable={false}
                  studText={studText}
                  onChange={(e) => changeOption(option.name, e)}
                  type={isType ? 1 : 0}
                  ringSize={1}
                  aria-label={optionName}
                ></CustomSelect>
              </div>
            </RingSizerOption>
          </RingSizerBlock>
        )
      } else {
        dropdowns.push(
          <div key={`${option.name}-${index}`}>
            <CustomSelect
              options={optionsData}
              styles={dropdownStyles(knowsSize === false)}
              filterOption={(option) =>
                knowsSize
                  ? !option.value.toLowerCase().includes("ring sizer")
                  : option.value.toLowerCase() === "decide later"
              }
              defaultValue={optionsData[0]}
              value={selected}
              isSearchable={false}
              studText={studText}
              onChange={(e) => changeOption(option.name, e)}
              type={isType ? 1 : 0}
              ringSize={1}
              aria-label={optionName}
            ></CustomSelect>
          </div>
        )
      }
    }

    if (!isColour) {
      const selected = optionsData.find((data) => data.label === selectedValue)
      dropdowns.push(
        <div key={index}>
          {!(isRing && isSize) && !isType && (
            <OptionName>{option.name}</OptionName>
          )}
          {(product.handle === "noma-letter-bracelet" || letterEdit) && (
            <NomaButton onClick={() => setIsLetterPopupOpen(true)}>
              {t("pdp.popup.noma_title")}
            </NomaButton>
          )}
          <CustomSelect
            options={optionsData}
            styles={dropdownStyles()}
            defaultValue={optionsData[0]}
            value={selected}
            isSearchable={false}
            studText={studText}
            onChange={(e) => changeOption(option.name, e)}
            type={isType ? 1 : 0}
            isRingSize={isRing && isSize}
            aria-label={optionName}
          ></CustomSelect>
        </div>
      )
    }

    if (isType) {
      dropdowns.push(
        <div key={`dsktop-${index}`}>
          <TypeOptions
            single={optionsData.length === 1 ? 1 : 0}
            cols={optionsData.length > 3 ? "2" : optionsData.length.toString()}
          >
            {optionsData.map((optionData) => {
              return (
                <TypeRadio key={optionData.value}>
                  {optionData.label}
                  <input
                    onChange={(e) => changeOption(option.name, optionData)}
                    value={optionData.value}
                    id={optionData.value}
                    name={optionName}
                    type="radio"
                    checked={selectedValue === optionData.value ? 1 : 0}
                  />
                  <span className="checkmark" />
                </TypeRadio>
              )
            })}
          </TypeOptions>
        </div>
      )
    }
  })

  const productTags = getProductTags(product, content)

  let engravingOptions = []
  let preorderProduct =
    getPreorderStatus(productTags) ||
    getVariantPreorderStatus(productTags, material?.handleValue)
  let saleProduct = false
  let discountAmount = 0
  let madeToOrder = getMadeToOrder(productTags, material)
  const shippingTime = getShippingTime(productTags, material)
  const optionsFromTags = []
  let signupProduct = false
  let signupUrl = ""
  const availableLondonStore = getTagExistence(
    "available-london",
    productTags,
    material
  )
  const inStock = getTagExistence("in-stock", productTags, material)

  // console.log(inStock)

  // temporary holiday shipping

  const shipHoliday = getTagExistence("ship-holiday", productTags, material)
  const shipNewYear = getTagExistence("ship-newyear", productTags, material)

  if (productTags.length > 0) {
    productTags.forEach((tag) => {
      if (tag.includes("discount-")) {
        saleProduct = true
        discountAmount = tag.match(/\d+/g)[0]
      }
      if (tag === "pairs") {
        isSoldIndividually = false
      }

      if (
        tag.includes("signup-") &&
        !tag.includes("signup-wave-of-stars-coming-soon")
      ) {
        signupProduct = true
        signupUrl = `/${tag.replace("signup-", "")}/signup`
      }

      if (tag.includes("Engraving")) {
        let engravingBasketName = t("pdp.engraving")
        let engravingName = t("pdp.engraving_personalized")
        let engravingType = "engraving"

        if (tag.includes("Front")) {
          engravingBasketName =
            engravingBasketName + " - " + t("pdp.engraving.front")
          engravingName = engravingName + " - " + t("pdp.engraving.front")
          engravingType = engravingType + "Front"
        } else if (tag.includes("Back")) {
          engravingBasketName =
            engravingBasketName + " - " + t("pdp.engraving.back")
          engravingName = engravingName + " - " + t("pdp.engraving.back")
          engravingType = engravingType + "Back"
        } else if (tag.includes("Link 1") || tag.includes("Link1")) {
          engravingBasketName =
            engravingBasketName + " - " + t("pdp.engraving.link") + "1"
          engravingName = engravingName + " - " + t("pdp.engraving.link") + " 1"
          engravingType = engravingType + "Link1"
        } else if (tag.includes("Link 2") || tag.includes("Link2")) {
          engravingBasketName =
            engravingBasketName + " - " + t("pdp.engraving.link") + "2"
          engravingName = engravingName + " - " + t("pdp.engraving.link") + " 2"
          engravingType = engravingType + "Link2"
        }

        engravingName = engravingName + ` (${t("pdp.engraving.optional")})`

        const engravingData = tag.split("-")
        let limit = 0

        if (engravingData.length > 1) {
          limit = engravingData[engravingData.length - 1]
        }

        engravingOptions.push({
          basketName: engravingBasketName,
          type: engravingType,
          name: engravingName,
          limit: limit,
        })
      }

      if (tag.includes("option-")) {
        const optionName = tag.split("-")[1]
        const existingOptionGroup = optionsFromTags.find(
          (obj) => obj.name === optionName
        )
        const value = tag
          .replace(/-order-(\d+)/, "")
          .replace(`option-${optionName}-`, "")
          .split("-")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")
          .replace("   ", " - ") //three empty spaces mean there's - used in the value

        const optionData = { value: value, label: getLocaleOptionValues(value) }

        if (!existingOptionGroup) {
          optionsFromTags.push({
            name: optionName,
            options: [optionData],
          })
        } else {
          existingOptionGroup.options.push(optionData)
        }
      }
    })

    if (optionsFromTags.length > 0) {
      optionsFromTags.forEach((option) => {
        const selected = option.options.find(
          (opt) => opt.value === braceletOptions[option.name]?.value
        )

        dropdowns.push(
          <div key={option.name}>
            <CustomSelect
              options={option.options}
              styles={dropdownStyles()}
              defaultValue={option.options[0]}
              isSearchable={false}
              value={selected}
              onChange={(e) => setBraceletOption(e, option.name)}
              aria-label={option.name}
            ></CustomSelect>
          </div>
        )
      })
    }

    if (
      wedding &&
      product.handle !== "stella-ring" &&
      product.handle !== "stellar-band"
    ) {
      engravingOptions.push({
        basketName: t("pdp.engraving"),
        type: "engraving",
        name: `${t("pdp.engraving_personalized")} (${t(
          "pdp.engraving.optional"
        )})`,
        limit: 10,
      })
    }
  }

  // if (content.inAntwerp) {
  //   madeToOrder = true
  // }

  let salePrice
  let productPrice = currentVariant.price || 0
  if (saleProduct) {
    salePrice = currentVariant.price * ((100 - discountAmount) / 100)
    productPrice = salePrice
  }

  const addToCart = (productImage, engraving = false) => {
    if (isLoading) {
      return
    }

    let productName = product.title
    let eventValue = selectedVariant.price
    let currency = product.priceRangeV2.minVariantPrice.currencyCode
    let variantId = selectedVariant.shopifyId.split("/").pop()

    cvgTrack({
      event: "Added To Cart",
      properties: {
        variant_id: selectedVariant.shopifyId.split("/").pop(),
        product_id: product.shopifyId.split("/").pop(),
        sku: product.handle,
        name: product.title,
        variant_name: selectedVariant.title,
        price: selectedVariant.price,
        currency: product.priceRangeV2.minVariantPrice.currencyCode,
        vendor: "kimai",
        quantity: 1,
      },
    })

    // Retention Tracking
    const productURL =
      process.env.WEBSITE_URL_WITH_PREFIX +
      getProductLinkByMaterial(
        content.urlKey,
        material?.value,
        product.createdAt,
        material ? false : true
      )

    var atcitem = {
      name: product.title,
      price: selectedVariant.price,
      productID: product.shopifyId.split("/").pop(),
      categories: product.tags,
      imageURL: product.media[0].image.src,
      URL: productURL,
      brand: "Kimaï",
    }

    if (window.location.href.includes("vge=true")) {
      console.log("Add To Cart Item:", atcitem)
    }

    const geq = window.geq

    if (typeof geq !== "undefined" && typeof geq.addToCart === "function") {
      geq.addToCart(atcitem)
    }

    let gtag = window.gtag

    if (typeof gtag === "function") {
      gtag("event", "add", {
        event_category: "Cart",
        event_label: productName + " - " + selectedVariant.title,
        value: eventValue,
      })

      gtag("event", "add_to_cart", {
        items: [
          {
            id: variantId,
            name: productName + " - " + selectedVariant.title,
            quantity: 1,
            price: eventValue,
          },
        ],
      })
    }
    let pintrk = window.pintrk
    let pinterestProductId = getPinterestProductId(product, selectedVariant)

    if (typeof pintrk === "function") {
      pintrk("track", "addtocart", {
        value: eventValue,
        order_quantity: 1,
        currency: currency,
        line_items: [
          {
            product_id: pinterestProductId,
          },
        ],
      })
    }

    let liQ = window.liQ
    const cart = storage.getItem("cart")
    let cartData

    if (cart) {
      cartData = JSON.parse(cart)
    }
    let userEmail = cartData ? cartData?.checkout?.email : ""

    if (typeof liQ !== "undefined") {
      liQ.push({
        event: "addToCart",
        email: userEmail,
        items: [
          {
            id: variantId,
            price: eventValue,
            quantity: 1,
            currency: currency,
          },
        ],
      })
    }

    addAction(
      [selectedVariant],
      1,
      productImage,
      { ...engagementOrderNumber, ...braceletOptions, ...engraving },
      false,
      false
    )
  }

  useEffect(() => {
    if (
      product.handle === "cube-men-bracelet" ||
      (letterEdit && selectedVariant)
    ) {
      const sizeOption = selectedVariant.selectedOptions.find(
        (option) => option.name.toLowerCase() === "size"
      )

      if (sizeOption) {
        const limit = sizeOption.value.replace(/[^0-9]/g, "")
        setEngravingLimit(limit)

        const newEngravings = { ...engravings } // Creating a copy of engravings

        // Update engraving values if the limit changes
        if (limit !== engravingLimit) {
          engravingOptions.forEach((engraving) => {
            const engravingType = engraving.type
            const engravingValue = newEngravings[engravingType]?.value

            if (engravings[engravingType]) {
              newEngravings[engravingType].value = engravingValue.slice(
                0,
                limit
              )
            }
          })
        }

        setEngravings(newEngravings)
      }
    }
  }, [selectedVariant])

  useEffect(() => {
    optionsFromTags.forEach((option) => {
      if (
        braceletOptions[option.name] === undefined &&
        option.options.length > 0
      ) {
        setBraceletOption(option.options[0], option.name)
      }
    })
  }, [])

  const { bannerHeight } = useBannerContext()

  let isOutOfStock =
    getGlobalOutOfStock(productTags) ||
    getVariantOutOfStock(productTags, material?.handleValue)

  const addToBagText = preorderProduct ? t("pdp.preorder") : t("pdp.add_to_bag")

  //update variant image by cord colour

  const cordOption = optionsFromTags.find(
    (option) => option.name.toLowerCase() === "cord"
  )

  if (cordOption?.options?.length >= 0 && braceletOptions[cordOption.name]) {
    let colorImage = product.media.find((image) =>
      image?.image?.altText?.includes(
        `cord-${braceletOptions[cordOption.name].value
          .toLowerCase()
          .split(" ")
          .join("-")}`
      )
    )

    if (colorImage) {
      mainImage = colorImage.image
    }
  }

  const madeToOrderExceptionProducts = [
    "tennis-bracelet",
    "atlas-necklace",
    "atlas-pave-necklace",
    "salazar-bracelet",
    "dolla-cuff",
    "splendido-earrings",
    "nava-tennis-necklace",
    "unico-bracelet",
    "harmony-necklace",
  ]

  // For the tags
  const noReturnsResizable = content.noReturnsResizable || isRing
  const hasMadeToOrderTag =
    madeToOrder ||
    isRing ||
    content.noReturnsResizable ||
    madeToOrderExceptionProducts.includes(product.handle)
  const noReturns =
    isRing || madeToOrderExceptionProducts.includes(product.handle)

  //SIZE
  // Define all non-resizable handles
  const nonResizableHandles = [
    "pebble-eternity-ring",
    "toto-georgia-band",
    "eternity",
    "stella-ring",
  ]

  const isEternityBand = product.handle.includes("eternity")

  const isResizable =
    (productType.includes("ring") || productType.includes("band")) &&
    !nonResizableHandles.includes(product.handle) &&
    !isEternityBand

  const showResizable =
    (productType.includes("ring") || productType.includes("band")) &&
    !productType.includes("earring")

  //RETURNS
  const noReturnsAccepted = (handle, productType) => {
    const noReturnHandles = [
      "nava-tennis-necklace",
      "milestone-necklace",
      "eclipse-pear-bangle",
      "musa-bracelet",
      "tennis-bracelet",
      "harmony-necklace",
      "unico-bracelet",
      "layla-earring",
      "splendido-earrings",
      "momento-necklace",
      "noma-letter-bracelet",
      "memory-bracelet",
      "salazar-bracelet",
      "stellar-band",
      "stella-ring",
      "atlas-pave-necklace",
      "atlas-necklace",
      "castle-eternity",
      "marquise-eternity",
      "eclipse-bangle",
    ]

    const productTypeValue = productType.toLowerCase()

    return (
      productTypeValue === "ring" ||
      productTypeValue === "rings" ||
      productTypeValue === "band" ||
      productTypeValue === "bands" ||
      productTypeValue === "bracelet men" ||
      noReturnHandles.includes(handle)
    )
  }

  const noReturnsIfEngraved = (handle) => {
    const engravedHandles = [
      "memory-bracelet",
      "unity-men-bracelet",
      "unity-necklace",
      "harness-men-bracelet",
      "cube-bracelet",
    ]
    return engravedHandles.includes(handle)
  }

  const extendedReturns = (handle, productType) => {
    const excludedHandles = [
      "nava-tennis-necklace",
      "milestone-necklace",
      "eclipse-pear-bangle",
      "musa-bracelet",
      "tennis-bracelet",
      "harmony-necklace",
      "unico-bracelet",
      "atlas-necklace",
      "atlas-pave-necklace",
    ]

    return (
      !excludedHandles.includes(handle) &&
      productType.toLowerCase() !== "ring" &&
      productType.toLowerCase() !== "rings" &&
      productType.toLowerCase() !== "band" &&
      productType.toLowerCase() !== "bands"
    )
  }

  let returnTag = {}
  if (product?.handle && product?.productType) {
    if (noReturnsAccepted(product.handle, product.productType)) {
      returnTag = { text: false }
    } else if (noReturnsIfEngraved(product.handle)) {
      returnTag = { text: false }
    }
    // else if (extendedReturns(product.handle, product.productType)) {
    //   returnTag = {
    //     text: isUS ? "Free 14-day returns" : "pdp.tags.extendedreturns",
    //   }
    // }
  }

  // ENGRAVING

  const eligibleForEngraving = [
    "memory-bracelet",
    "unity-men-bracelet",
    "harness-men-bracelet",
    "cube-men-bracelet",
    "astra-rings",
    "kayla-ring",
    "numa-pave-ring",
    "tara-flow-ring",
    "bode-ring",
    "aurora-galactic-ring",
    "aurora-ring",
  ]
  const isWeddingBand =
    product.productType.toLowerCase().includes("band") &&
    product.productType.toLowerCase().includes("wedding")

  const hasComplimentaryEngraving =
    eligibleForEngraving.includes(product.handle) || isWeddingBand

  return (
    <BlockContainer>
      <Block top={bannerHeight + 113}>
        <BreadcrumbsContainer>
          <ProductBreadcrumbs
            product={product}
            collections={collections}
            wedding={product.productType === "wedding band"}
          />
        </BreadcrumbsContainer>
        <Grid>
          <div>
            <Mobile>
              <ProductGallery
                mainImageNumber={selectedVariant ? mainImageNumber : null}
                sliderImages={[mainImage, ...sliderImages].slice(0, 8)}
                productName={title}
              />
            </Mobile>
            <Desktop>
              <ProductImageLayout
                sliderImages={sliderImages.slice(0, 3)}
                mainImage={mainImage}
                productName={title}
              />
            </Desktop>
          </div>
          <Sticky top={bannerHeight}>
            <Details>
              {saleProduct && (
                <DiscountSticker>{discountAmount}</DiscountSticker>
              )}
              <TitleSection>
                <div>
                  <ProductTitle>{title}</ProductTitle>
                  {/* <PageTitle>
                    {material ? replaceMaterialWord(h1, material.color) : h1}
                  </PageTitle> */}
                </div>
                <PriceSection sale={salePrice ? 1 : 0}>
                  {/* <span className="currency">{getCurrencySymbol()}</span> */}

                  <Price $crossed={salePrice ? 1 : 0}>
                    {getLocalisedPrice(
                      currentVariant.price,
                      product.priceRangeV2.minVariantPrice.currencyCode
                    )}
                    {salePrice && <Line />}
                  </Price>
                  {salePrice && (
                    <Price sale>
                      {getLocalisedPrice(
                        salePrice,
                        product.priceRangeV2.minVariantPrice.currencyCode
                      )}
                    </Price>
                  )}
                </PriceSection>
              </TitleSection>
              <WidgetContainer>
                {(activeEnv === "us" ||
                  activeEnv === "uk" ||
                  activeEnv === "development") && (
                  <KlarnaWidget price={productPrice * 100} />
                )}
                {(activeEnv === "fr" ||
                  activeEnv === "eu" ||
                  activeEnv === "development") && (
                  <AlmaWidget price={productPrice * 100} />
                )}
              </WidgetContainer>
              {colorOptions.length > 0 && (
                <ColorOptions>
                  <ColorOptionName>{t("pdp.options.colour")} :</ColorOptionName>
                  <ColorOptionValues>
                    {colorOptions.map((colorOption) => {
                      const isSelected =
                        colorOption.value.toLowerCase() === material.value

                      const link = getProductLinkByMaterial(
                        content.urlKey,
                        colorOption.value.toLowerCase(),
                        product.createdAt
                      )

                      const newOptionsData = { ...options }

                      newOptionsData[colorOptionName] = colorOption.value

                      return (
                        <ColorOptionValueLink
                          key={colorOption.value}
                          selected={isSelected ? 1 : 0}
                          to={link}
                          state={{
                            engravings,
                            options: newOptionsData,
                            engravingLimit,
                            braceletOptions,
                          }}
                        >
                          <img src={colorOption.icon} alt={colorOption.label} />
                        </ColorOptionValueLink>
                      )
                    })}
                  </ColorOptionValues>
                </ColorOptions>
              )}

              {dropdowns}
              {product.handle !== "marquise-eternity" &&
                engravingOptions.length > 0 && (
                  <>
                    {engravingOptions.map((engraving, index) => {
                      const isCubeMenBracelet =
                        product.handle === "cube-men-bracelet"
                      const limit =
                        isCubeMenBracelet || letterEdit
                          ? engravingLimit
                          : engraving.limit || 30
                      const charLength =
                        engravings[engraving.type]?.value?.length || 0
                      const value = engravings[engraving.type]
                        ? engravings[engraving.type].value
                        : ""

                      const placeholder = isCubeMenBracelet
                        ? t("pdp.engraving_personalized") +
                          ` - (${limit} letter/bead maximum)`
                        : letterEdit
                          ? t("pdp.engraving_personalized") +
                            ` - (${limit} letter)`
                          : engraving.name

                      return (
                        <EngravingContainer key={index}>
                          <OptionalEngraving
                            key={index}
                            maxLength={limit || 30}
                            onChange={(e) => setEngraving(e, engraving)}
                            placeholder={placeholder}
                            value={value}
                          />
                          <label>
                            {charLength}/{limit}{" "}
                            {limit > 1
                              ? t("pdp.characters")
                              : t("pdp.character")}
                          </label>
                        </EngravingContainer>
                      )
                    })}
                  </>
                )}
              {productType === "wedding band" && (
                <OrderNumberFieldContainer>
                  <OptionalEngraving
                    onChange={(e) => setEngagementRingOrderNumberValue(e)}
                    placeholder={t("pdp.wb.er_order_number")}
                  />
                  <label>{t("pdp.wb.er_order_number.optional")}</label>
                </OrderNumberFieldContainer>
              )}
            </Details>
            {isUK && availableLondonStore && (
              <Message>
                Available at our <Link to="/london-store">London store</Link>.
              </Message>
            )}
            {shipHoliday && <Message>{t("pdp.shipping.holiday")}</Message>}
            {shipNewYear && <Message>{t("pdp.shipping.newyear")}</Message>}
            {!madeToOrder &&
              !isOutOfStock &&
              inStock &&
              !shipNewYear &&
              !shipHoliday && (
                <Message>
                  {t("pdp.status.in_stock")} - {t("pdp.ships_within")}{" "}
                  {shippingTime}
                </Message>
              )}
            {isOutOfStock && !signupProduct && (
              <Message>{t("pdp.status.out_of_stock")}</Message>
            )}
            {/* {signupProduct && <Message>{t("pdp.signup.copy")}</Message>} */}
            <DetailList $hiddenMb={madeToOrder ? 0 : 1} $hiddenDesktop={1}>
              {/* {!isOutOfStock && madeToOrder && !shipNewYear && !shipHoliday && (
                <li>
                  <img
                    src={ShippingIcon}
                    alt="shipping"
                    width="24"
                    height="25"
                  />
                  {t("pdp.status.made_to_order")} {shippingTime}
                </li>
              )} */}

              <li>
                <img src={HeartIcon} alt="heart" /> {t("pdp.tax_duties")}
              </li>

              <li>
                <img src={HeartIcon} alt="heart" /> {t("pdp.tax_duties")}
              </li>
              {/* {productType === "earrings" && (
                <li>
                  <img src={HandsIcon} alt="heart" />{" "}
                  {isSoldIndividually
                    ? t("pdp.sold_individually")
                    : t("pdp.sold_as_pair")}
                </li>
              )} */}
            </DetailList>

            <AddToBagContainer>
              {signupProduct ? (
                <ButtonGreen to={signupUrl}>{t("pdp.signup.list")}</ButtonGreen>
              ) : comingSoon ? (
                <ComingSoonButton disabled>COMING SOON</ComingSoonButton>
              ) : (
                <OnClickButtonGreen
                  disabled={isOutOfStock}
                  onClick={() => addToCart(mainImage, engravings)}
                >
                  {isAdded === true
                    ? t("pdp.added")
                    : isOutOfStock
                      ? t("pdp.out_of_stock")
                      : addToBagText +
                        getLocalisedPrice(
                          productPrice,
                          product.priceRangeV2.minVariantPrice.currencyCode
                        )}
                </OnClickButtonGreen>
              )}
            </AddToBagContainer>
            <Whatsapp
              href={`${isFrance ? `https://api.whatsapp.com/send/?phone=%2B33623046861&text&type=phone_number&app_absent=0` : `https://wa.me/+447897789225`}`}
              target="_blank"
              rel="noreferrer noopener"
            >
              <img src={WhatsappImg} alt="Share on Whatsapp" />
              <WhatsappText>{t("bespoke.form.whatsapp")}</WhatsappText>
            </Whatsapp>
            <IconsContainer>
              {/* <IconWrapper>
                <img src={GlobeIcon} alt={t("pdp.tags.freeshipping")} />
                <IconsText>{t("pdp.tags.freeshipping")}</IconsText>
              </IconWrapper> */}

              {productType === "earrings" ? (
                <IconWrapper>
                  <img src={DiamondIcon} alt="Diamond Icon" />
                  <IconsText>
                    {["splendido-earrings", "stud-earrings"].includes(
                      product.handle
                    )
                      ? t("pdp.tags.soldperpair")
                      : [
                            "legato-earring",
                            "stellar-hoop-earring",
                            "daisy-earring",
                            "stellar-earcuff",
                            "twinstar-hoop",
                          ].includes(product.handle)
                        ? t("pdp.tags.soldperunit")
                        : t("pdp.tags.soldperunit")}
                  </IconsText>
                </IconWrapper>
              ) : null}

              {product.handle !== "galactic-letter-charm" &&
              engravingOptions.length >= 1 ? (
                <IconWrapper>
                  <IconsText>{t("pdp.tags.engraving")}</IconsText>
                </IconWrapper>
              ) : null}

              {(productType === "rings" ||
                [
                  "splendido",
                  "nava-necklace",
                  "dolla-cuff",
                  "halo-earring",
                  "musa-bracelet",
                  "atlas-necklace",
                  "atlas-pave-necklace",
                  "salazar-bracelet",
                  "layla-earring",
                  "miro-earring",
                  "tennis-bracelet",
                  "harmony-necklace",
                  "unico-necklace",
                  "eclipse-pear-bangle",
                  "eclipse-bangle",
                  "milestone-necklace",
                ].includes(product.handle)) && (
                <IconWrapper>
                  <IconsText>{t("pdp.tags.madetoorder")}</IconsText>
                </IconWrapper>
              )}

              {inStock && (
                <IconWrapper>
                  <IconsText>{t("pdp.tags.instock")}</IconsText>
                </IconWrapper>
              )}
              {/* Ships within X weeks or 1 week */}
              {!inStock && shippingTime && (
                <IconWrapper>
                  <img src={ShippingIcon} alt="Shipping Icon" />
                  <IconsText>
                    {[
                      "legato-earring",
                      "nocturne-choker-necklace",
                      "stellar-hoop-earring",
                      "stellar-ear-cuff",
                      "twin-star-hoop",
                      "ada-3ct-ring",
                      "daisy-earring",
                      "dilly-bangle",
                      "galactic-bangle",
                    ].includes(product.handle)
                      ? t("pdp.tags.shipping7")
                      : shippingTime === 1
                        ? t("pdp.tags.shipping7")
                        : t("pdp.tags.shippingX", { weeks: shippingTime })}
                  </IconsText>
                </IconWrapper>
              )}

              {showResizable && isResizable && (
                <IconWrapper>
                  <img src={HeartIcon} alt="Heart Icon" />
                  <IconsText>{t("pdp.tags.resizable")}</IconsText>
                </IconWrapper>
              )}
            </IconsContainer>

            <DetailList $hiddenMb={madeToOrder ? 1 : 0}>
              {/* {typeof window !== "undefined" &&
    (
      ![
        "/product/yellow-gold-lili-earring/",
        "/product/rose-gold-lili-earring/",
        "/product/white-gold-lili-earring/",
        "/product/yellow-gold-nemo-earring/",
        "/product/rose-gold-nemo-earring/",
        "/product/white-gold-nemo-earring/",
        "/product/yellow-gold-heartbeat-earring/",
        "/product/white-gold-heartbeat-earring/",
        "/product/yellow-gold-onda-ear-cuff/",
        "/product/white-gold-onda-ear-cuff/",
        "/product/yellow-gold-lumi-earring/",
        "/product/rose-gold-lumi-earring/",
        "/product/yellow-gold-beam-earring/",
        "/product/yellow-gold-glow-earring/",
        "/product/yellow-gold-kaia-earring/",
        "/product/white-gold-kaia-earring/",
        "/product/yellow-gold-ela-earring/",
        "/product/rose-gold-ela-earring/",
        "/product/white-gold-ela-earring/",
        "/product/rose-gold-duo-necklace/",
        // French versions
        "/produit/or-jaune-boucle-d-oreille-lili/",
        "/produit/or-rose-boucle-d-oreille-lili/",
        "/produit/or-blanc-boucle-d-oreille-lili/",
        "/produit/or-jaune-boucle-d-oreille-nemo/",
        "/produit/or-rose-boucle-d-oreille-nemo/",
        "/produit/or-blanc-boucle-d-oreille-nemo/",
        "/produit/or-jaune-heartbeat-earring/",
        "/produit/or-blanc-heartbeat-earring/",
        "/produit/or-jaune-boucle-d-oreille-onda/",
        "/produit/or-blanc-boucle-d-oreille-onda/",
        "/produit/or-jaune-lumi-earring/",
        "/produit/or-rose-lumi-earring/",
        "/produit/or-jaune-beam-earring/",
        "/produit/boucle-d-oreille-glow/",
        "/produit/or-jaune-kaia-earring/",
        "/produit/or-blanc-kaia-earring/",
        "/produit/or-jaune-ela-hoop-earring/",
        "/produit/or-rose-ela-hoop-earring/",
        "/produit/or-blanc-ela-hoop-earring/",
        "/produit/or-rose-collier-duo/",
      ].includes(path) &&
      !path.includes("-ring") &&
      !isUS
    ) && (
      <li>
        <img src={ShippingIcon} alt="guaranteed" />
        {t("pdp.tags.guaranteed")}
      </li> */}
              {/* )} */}
              {typeof window !== "undefined" &&
                [
                  "legato-earring",
                  "nocturne-choker-necklace",
                  "stellar-ear-cuff",
                  "twin-star-hoop",
                  "ada-3ct-ring",
                  "galactic-bangle",
                ].includes(product.handle) && (
                  <li>
                    <img src={BoxIcon} alt="Unique Icon" />
                    {t("pdp.return.unique")}
                  </li>
                )}
              {typeof window !== "undefined" &&
                returnTag.text &&
                ![
                  "legato-earring",
                  "nocturne-choker-necklace",
                  "stellar-hoop-earring",
                  "stellar-ear-cuff",
                  "twin-star-hoop",
                  "ada-3ct-ring",
                  "daisy-earring",
                  "dilly-bangle",
                  "galactic-bangle",
                ].includes(product.handle) && (
                  <li>
                    <img src={BoxIcon} alt="Box Icon" />
                    {t(returnTag.text)}
                  </li>
                )}
              <li>
                <img src={HeartIcon} alt="heart" />
                {t("pdp.tax_duties")}
              </li>
              <li>
                <img src={HandsIcon} alt="heart" />
                <p>
                  {t("pdp.lifetimewarranty")}{" "}
                  <LearnMoreLink href="/faq">
                    {t("pdp.learn_more")}
                  </LearnMoreLink>
                </p>
              </li>
            </DetailList>

            <InfoColumns
              product={product}
              description={description}
              content={content}
              title={title}
            />
          </Sticky>
        </Grid>
      </Block>
      <SizeChartPopup
        handlePopup={setIsChartPopupOpen}
        open={isChartPopupOpen}
      />
      <RingSizerPopup
        handlePopup={setIsSizerPopupOpen}
        open={isSizerPopupOpen}
      />
      {product.handle === "noma-letter-bracelet" && (
        <NomaPopup
          handlePopup={setIsLetterPopupOpen}
          open={isLetterPopupOpen}
        />
      )}
      {letterEdit && (
        <MementoPopup
          handlePopup={setIsLetterPopupOpen}
          isGalactic={product.handle.includes("galactic") ? true : false}
          open={isLetterPopupOpen}
        />
      )}
    </BlockContainer>
  )
}

const mapStateToProps = (state) => {
  return {
    isLoading: isLoading(state),
    isAdded: isAdded(state),
  }
}

const mapDispatchToProps = {
  addAction,
}

const TranslatedProductDetailsBlock = withTranslation()(ProductDetails)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TranslatedProductDetailsBlock)
